import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";
import { INSIGHTS } from "@/content/pages-insights";
import { NAV } from "@/content/nav";
import { Eyebrow, Reveal } from "@/components/Reveal";

export default function ArticlePage() {
  const { slug } = useParams();
  const { lang } = useLang();
  const article = INSIGHTS.find((a) => a.slug === slug);
  const band = NAV[lang].ctaBand;

  if (!article) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FBF8F3] pt-[72px]">
        <Link to="/insights" className="font-mono text-xs uppercase tracking-[0.2em] text-[#B36C45]">
          ← Insights
        </Link>
      </div>
    );
  }

  return (
    <div data-testid={`article-${slug}`}>
      <div className="bg-[#FBF8F3] pb-16 pt-40 sm:pt-48">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Link
            to="/insights"
            data-testid="article-back-link"
            className="mb-10 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-[#5C6B64] transition-colors hover:text-[#B36C45]"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Insights
          </Link>
          <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#B36C45]">
            <Eyebrow>{article.category[lang]}</Eyebrow>
          </div>
          <h1 className="mt-6 font-display text-3xl font-bold leading-[1.1] tracking-tight text-[#0A1F18] sm:text-5xl">
            {article.title[lang]}
          </h1>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5C6B64]">
            {article.date[lang]} · {article.read}
          </p>
        </div>
      </div>

      <section className="bg-[#F3EFE6] py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="font-serif text-xl italic leading-relaxed text-[#0A1F18] sm:text-2xl">
              {article.excerpt[lang]}
            </p>
          </Reveal>
          {article.body[lang].map((p, i) => (
            <Reveal key={i} delay={0.05}>
              <p className="mt-7 text-base leading-relaxed text-[#5C6B64]">{p}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#C87D55] py-14">
        <div className="mx-auto flex max-w-3xl flex-col items-start gap-6 px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-2xl font-semibold tracking-tight text-[#FBF8F3] sm:text-3xl">
            {band.title}
          </h2>
          <Link
            to="/contact"
            data-testid="article-cta-button"
            className="bg-[#0A1F18] px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] text-[#FBF8F3] transition-colors hover:bg-[#153328]"
          >
            {band.button}
          </Link>
        </div>
      </section>
    </div>
  );
}
